import { Group } from "app/types"

type HasJoinedGroupProps = {
  userGroups?: {
    group: Pick<Group, 'id'>
    isModerator?: boolean
    isOwner?: boolean
  }[]
  groupId?: string
}

export const hasJoinedGroup = ({
  userGroups,
  groupId,
}: HasJoinedGroupProps) => {
  if (!groupId || !userGroups?.length) {
    return {
      isMember: false,
      isAdmin: false,
    }
  }

  const isMember = userGroups.some(
    (group) => group?.group.id === groupId)

  const isAdmin = userGroups.some(
    (group) => group?.group.id === groupId && (group?.isModerator || group?.isOwner))


  return { isMember, isAdmin }
}

